/* eslint-disable */
// @ts-nocheck
import React from "react";
import { Toggle, FormLabel } from "@carbon/react";
import FieldTooltip from "../tooltip/Tooltip";
import { TOGGLE_TRANSLATIONS } from "../../translations/util";

interface IProps {
  id?: string;
  className?: string;
  labelText?: string;
  disabled?: boolean;
  onChange: (value: boolean) => void;
  value?: boolean;
  defaultToggled?: boolean;
  tooltipText?: string;
}

const ToggleField = ({
  id,
  className,
  labelText,
  disabled = false,
  onChange,
  value,
  defaultToggled,
  tooltipText,
}: IProps) => {
  return (
    <div className="form-wrapper">
      {labelText ? (
        <FormLabel data-cy={`${labelText.replaceAll(" ", "")}-togglelabel`}>
          {" "}
          {labelText}{" "}
        </FormLabel>
      ) : null}
      {tooltipText ? (
        <FieldTooltip
          label={tooltipText}
          fieldName={`${labelText.replaceAll(" ", "")}-`}
        />
      ) : null}
      <Toggle
        id={id || labelText}
        toggled={value}
        className={className}
        onToggle={(val: boolean) => onChange(val)}
        labelA={TOGGLE_TRANSLATIONS.labelA}
        labelB={TOGGLE_TRANSLATIONS.labelB}
        disabled={disabled}
        defaultToggled={defaultToggled}
      />
    </div>
  );
};

export default ToggleField;
